import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineEmail, MdArrowForward, MdCheckBox, MdCheckCircle } from 'react-icons/md';


const ForgotPassword = ({ history }) => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); //idle | loading | sent
    const [error, setError] = useState('');

    const validate = () => {
        if (!email.trim()) return 'Email address is required.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
            return 'Please enter a valid email address.';
        return null;
    };
 
    const handleSubmit = async () => {
        const validationError = validate();
        if (validationError) {
            setError(validationError);
            return;
        }
        setError('');
        setStatus('loading');
 
        try {
            const response = await fetch('api/Account/SendResetPasswordEmail', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Email: email.trim() }),
            });
 
            // Always show sent state regardless of response
            // to avoid revealing whether an account exists
            setStatus('sent');
        } catch (err) {
            console.error('SendResetPasswordEmail error:', err);
            // Still show sent state - don't reveal errors
            setStatus('sent');
        }
    };
 
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') handleSubmit();
    };
 
    return (
        <div className="page-centered">
            <div className="card" style={{ width: '100%', maxWidth: '660px' }}>
                {status !== 'sent' ? (
                    <>
                        <div style={{ textAlign: 'left', marginBottom: 'var(--space-xl)' }}>
                            <h4 className="h4" style={{ margin: '0 0 var(--space-xs)' }}>
                                Request password
                            </h4>
                            <p className="small" style={{ margin: 0 }}>
                                Enter your email address and we'll send you a link to reset
                                your password.
                            </p>
                        </div>
 
                        {/* Email */}
                        <div className="form-group">
                            <label className="form-label">Enter your email</label>
                            <div className="input-icon-wrap">
                                <span className="input-icon">
                                    <MdOutlineEmail size={16} />
                                </span>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setError('');
                                    }}
                                    onKeyPress={handleKeyPress}
                                    disabled={status === 'loading'}
                                />
                            </div>
                            {error && (
                                <span className="error-text">{error}</span>
                            )}
                        </div>
 
                        <div style={{ marginTop: 'var(--space-xs)' }}>
                            <button
                                className="btn"
                                onClick={handleSubmit}
                                disabled={status === 'loading'}
                                style={{ width: '100%' }}
                            >
                                {status === 'loading' ? 'Sending…' : 'Send reset link'}
                                {status !== 'loading' && <MdArrowForward size={16} />}
                            </button>
                        </div>
 
                        <div style={{ textAlign: 'center', marginTop: 'var(--space-lg)' }}>
                            <Link to="/login" className="auth-link">Back to login</Link>
                        </div>
                    </>
                ) : (
                    <>
                        {/* Success state */}
                        <div style={{ textAlign: 'left', marginBottom: 'var(--space-xl)' }}>
                            <h4 className="h4" style={{ margin: '0 0 var(--space-xs)' }}>
                                Request password
                            </h4>
                            <p className="small" style={{ margin: 0 }}>
                                Enter your email address and we'll send you a link to reset
                                your password.
                            </p>
                        </div>
 
                        <div className="input-icon-wrap" style={{ marginBottom: 'var(--space-md)' }}>
                            <span className="input-icon">
                                <MdOutlineEmail size={16} />
                            </span>
                            <input
                                type="email"
                                value={email}
                                disabled
                                style={{ opacity: 0.6 }}
                            />
                        </div>
 
                        {/* Success banner */}
                        <div className="eligibility-success">
                            <MdCheckCircle size={20} className="eligibility-success__icon" />
                            <div className="eligibility-success__text">
                                <strong>Password reset email sent</strong>
                                <p>Check your inbox for a link to reset your password. If it
                                    doesn't arrive within a few minutes, check your spam folder.</p>
                            </div>
                        </div>
 
                        <div style={{ textAlign: 'center', marginTop: 'var(--space-lg)' }}>
                            <Link to="/login" className="auth-link">Back to login</Link>
                        </div>
                    </>
                )}
 
                <p className="small" style={{ textAlign: 'center', margin: 'var(--space-md) 0 0' }}>
                    Don't have an account?{' '}
                    <a href="/signup/eligibility" className="auth-link"
                        style={{ fontWeight: 'var(--weight-semibold)' }}>
                        Get a quote
                    </a>{' '}
                    {status === 'sent' ? 'today.' : 'today'}
                </p>

            </div>
        </div>
    );
}

export default ForgotPassword